module.exports = {
  "/": {
    "success": {
      "index page loaded": [
        "INDEX_LOAD"
      ],
      "not found page loaded": [
        "NOT_FOUND_LOAD"
      ]
    }
  }
};